import { useContext, useMemo, useState } from 'react';
import { CheckoutContextProps } from '../../../../context/CheckoutContext';
import { CheckoutContext } from '../../../../context/CheckoutContext';
import {
  DSW_COMPANY_ID,
  DUBAI_FITNESS_CHALLENGE_COMPANY_ID,
  DFC_SCHOOL_EXPERIENCE_COMPANY_ID,
  ROUTES_WITHOUT_CART_ICON,
  DANUBE_SPORTS_WORLD_COMPANY_ID
} from '../../../../Utils/constants';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Company } from '../../../../hooks/useCompany';
import { useAuth } from '../../../../context/AuthContext';
import { isValidUser } from '../../../../Utils/validate';
import { rememberPostAuthReturn } from '../../../../Utils/postAuthReturn';

export const useHeader = (company?: Company) => {
  const { bookingCart, countdownApi, selectedSession } = useContext(
    CheckoutContext
  ) as CheckoutContextProps;
  const { user } = useAuth();
  const [isAccountQrModalOpen, setIsAccountQrModalOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const showCart = useMemo(
    () => !ROUTES_WITHOUT_CART_ICON.includes(location.pathname.toLowerCase()),
    [location.pathname]
  );

  const handleNavigateToCart = () => {
    navigate(`/Cart?companyId=${company?.id}`);
  };

  const handleNavigateToProfile = () => {
    navigate(`/My-profile?companyId=${company?.id}`);
  };

  const handleAccountClick = () => {
    if (!isValidUser(user)) {
      rememberPostAuthReturn(selectedSession);
      navigate(`/Register?companyId=${company?.id}`);
      return;
    }

    if (company?.enableQRCode) {
      setIsAccountQrModalOpen(true);
      return;
    }

    handleNavigateToProfile();
  };

  const handleCloseAccountQrModal = () => {
    setIsAccountQrModalOpen(false);
  };

  const handleViewProfileFromQrModal = () => {
    setIsAccountQrModalOpen(false);
    handleNavigateToProfile();
  };

  const showAccount = Boolean(company?.hasAuthentication);
  const qrCodeValue = user?.id || '';

  const handleLogoClick = () => {

    if ([DUBAI_FITNESS_CHALLENGE_COMPANY_ID, DSW_COMPANY_ID, DANUBE_SPORTS_WORLD_COMPANY_ID, DFC_SCHOOL_EXPERIENCE_COMPANY_ID].includes(company?.id || '')) {
      // Already home: navigating to the same URL changes nothing on screen, so take the
      // visitor back to the top instead (DFC 12/10: "clickable, but doesn't re-direct").
      if (location.pathname === '/') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      navigate(`/?companyId=${company?.id}`);
    } else {
      window.location.href = company?.website || '/';
    }
  };

  return {
    showCart,
    showAccount,
    handleNavigateToCart,
    handleAccountClick,
    handleCloseAccountQrModal,
    handleViewProfileFromQrModal,
    handleLogoClick,
    bookingCart,
    company,
    countdownApi,
    location,
    isAccountQrModalOpen,
    qrCodeValue,
  };
};

export default useHeader;
